/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseModel } from './BaseModel';
import {
    BaseModelFromJSON,
    BaseModelFromJSONTyped,
    BaseModelToJSON,
} from './BaseModel';
import type { DiseaseAllOf } from './DiseaseAllOf';
import {
    DiseaseAllOfFromJSON,
    DiseaseAllOfFromJSONTyped,
    DiseaseAllOfToJSON,
} from './DiseaseAllOf';

/**
 * 
 * @export
 * @interface Disease
 */
export interface Disease {
    /**
     * 
     * @type {number}
     * @memberof Disease
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Disease
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Disease
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Disease
     */
    diseaseName?: string;
}

/**
 * Check if a given object implements the Disease interface.
 */
export function instanceOfDisease(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiseaseFromJSON(json: any): Disease {
    return DiseaseFromJSONTyped(json, false);
}

export function DiseaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Disease {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'diseaseName': !exists(json, 'diseaseName') ? undefined : json['diseaseName'],
    };
}

export function DiseaseToJSON(value?: Disease | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'diseaseName': value.diseaseName,
    };
}

